<template>
  <f7-page id="page-sendmoney-confirmation" name="sendmoney-confirmation" @page:afterin="afterin();">
    <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link icon-f7="chevron_left" @click="handleBackButton()" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right>
          <f7-link></f7-link>
        </f7-nav-right>
      </div>
    </f7-navbar>

    <f7-block>
      <!-- ALERT MESSAGE -->
      <f7-card
        id     = "errorCard"
        class  = "alert"
        v-show = "alertCard.show"
        :class = "alertCard.alertClass"
        >
        <div v-html="alertCard.title" slot="header"></div>
          <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
      </f7-card>

      <!-- PAGE TITLE -->
      <div class="wandr-level-4">{{$t('sendmoney-confirmation-page-title')}}</div>
      <div class="mb-20 wandr-level-2 mt-xxl">{{$t('sendmoney-text-recipient')}}</div>

      <!-- BENEFICIARY CARD SECTION -->
      <recipientCardComponent :isQuickSend="isQuickSend" :isDisplayAsCard="true" />

      <PhilGovDetailCard />

      <div class="mb-20 wandr-level-2 mt-20">{{$t('sendmoney-text-transfer')}}</div>

      <!-- PAYMENT SUMMARY SECTION -->
      <div class="card card-20 payment-summary">
        <div class="mb-20 wandr-level-3">{{$t('sendmoney-text-payment-summary')}}</div>
        <div class="payment-details">
          <div>
            <div>{{$t('sendmoney-label-you-send')}}</div>
            <div>{{this.formatCurrency(hostObj.amountReal, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div>
            <div>{{$t('sendmoney-text-commision')}}
              <f7-link popover-open=".popover-commision-info-2" class="info">
                <i class="icon f7-icons color-green pl-sm" id="infoCommisionIcon-2">icon_info_circle</i>
              </f7-link>
            </div>
            <div>{{this.formatCurrency(commissionAmount, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div>
            <div>{{$t('sendmoney-text-convenience-fee')}}</div>
            <div>{{this.formatCurrency(convenienceTotalFees, 2) || 0}} {{hostCurrency}}</div>
          </div>
          <div v-if="discountAmount > 0">
            <div>{{$t('sendmoney-text-discount')}}</div>
            <div>- {{this.formatCurrency(discountAmount, 2) || 0}} {{hostCurrency}}</div>
          </div>
        </div>
        <div class="payment-total">
          <div class="wandr-level-3">{{$t('sendmoney-text-you-pay')}}</div>
          <div class="wandr-level-4">{{this.formatCurrency(payable, 2) || 0}} {{hostCurrency}}</div>
        </div>
      </div>
    </f7-block>

    <f7-popover class="popover-commision-info-2 info" :backdrop="true">
        <div class="fs-10 fw-medium">
          {{$t('sendmoney-text-commission')}}
        </div>
    </f7-popover>

    <f7-block class="mt-xxl mb-xl">
      <f7-button style="display:flex;align-items: center;" large fill round @click="handleConfirmContinue()">
        {{$t('sendmoney-continue')}}
      </f7-button>
    </f7-block>

    <!-- Checkout Payment with Credit Card -->
    <!-- <CheckoutPaymentComponent :frameURL="checkoutPaymentURL" @sheetClosed="checkoutCompleted" /> -->
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex"
  import PhilGovDetailCard          from '@/components/beneficiary-philgov-detail-card'
  import recipientCardComponent     from '@/components/recipient-card'
  // import CheckoutPaymentComponent   from '@/components/iframe-sheet-modal'

  export default {
    data() {
			return {
        alertCard: {
          show              : false,
          title             : "",
          content           : "",
          alertClass        :"alert-danger"
        },
        bankId              : 0,
        bankAccountNo       : "",
        bankName            : "",
        bankExpressId       : 0,
        bankTypeId          : 0,
        beneficiaryFirstName: "",
        billingOrg          : "",
        city                : "",
        collectionAgent     : "",
        commissionAmount    : 0,
        convenienceFee      : 0,
        convenienceFeeByPercentage: 0,
        convenienceTotalFees: 0,
        couponCode          : "",
        deliveryMethodId    : 0,
        discountAmount      : 0,
        homeCountryId       : 0,
        hostCountryId       : 0,
        hostCurrency        : "",
        hostObj             : { amount: "", amountReal: 0 },
        homeObj             : { amount: "", amountReal: 0 },
        isQuickSend         : true,
        payable             : 0,
        paymentPurpose      : "",
        paymentPurposeOther : "",
        paymentMethodId     : 0,
        province            : "",
        settlementId        : 0,
        totalAmountPayable  : 0,
        transactionId       : 0,
        transactionTypeId   : 0,
        checkWindow         : undefined,
        checkTimer          : null,
        // checkoutPaymentURL  : '',
			}
		},
    mounted(){
      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      this.bankId = this.$store.state.transaction.bankId
      this.bankAccountNo = this.$store.state.transaction.bankAccountNo
      this.bankName = this.$store.state.transaction.bankName
      this.beneficiaryId = this.$store.state.transaction.beneficiaryId
      this.beneficiaryFirstName = this.$store.state.transaction.beneficiaryFirstName
      this.billingOrg = this.$store.state.transaction.billingOrg
      this.city = this.$store.state.transaction.city
      this.collectionAgent = this.$store.state.transaction.collectionAgent
      this.commissionAmount = this.$store.state.transaction.commissionAmount
      this.convenienceFee = this.$store.state.transaction.convenienceFee
      this.convenienceFeeByPercentage = this.$store.state.transaction.convenienceFeeByPercentage
      this.convenienceTotalFees = this.$store.state.transaction.convenienceTotalFees
      this.couponCode = this.$store.state.transaction.couponCode
      this.deliveryMethodId = this.$store.state.transaction.deliveryMethodId
      this.discountAmount = this.$store.state.transaction.discountAmount
      this.homeCountryId = this.$store.state.transaction.homeCountryId
      this.hostCountryId = this.$store.state.transaction.hostCountryId
      this.hostCurrency = this.$store.state.transaction.hostCurrency

      this.paymentMethodId = this.$store.state.transaction.paymentMethodId
      this.paymentPurposeId = this.$store.state.transaction.paymentPurposeId
      this.paymentPurpose = this.$store.state.transaction.paymentPurpose
      this.paymentPurposeOther = this.$store.state.transaction.paymentPurposeOther
      this.province = this.$store.state.transaction.province
      this.totalAmountPayable = this.$store.state.transaction.totalAmountPayable

      this.hostObj.amountReal = this.$store.state.transaction.hostAmountReal
      this.homeObj.amountReal = this.$store.state.transaction.homeAmountReal


      this.hostObj.amount = this.formatCurrency(this.hostObj.amountReal, 2);
      this.homeObj.amount = this.formatCurrency(this.homeObj.amountReal, 2);
      this.payable = ( parseFloat(this.totalAmountPayable) + parseFloat(this.convenienceTotalFees)) // without Convenience Fee

      this.$store.state.transaction.totalAmountSettlement = this.payable
      this.transactionTypeId = this.$store.state.transaction.transactionTypeId
      this.bankExpressId = this.$store.state.transaction.bankExpressId

      window.checkoutCompleted = this.checkoutCompleted;

      this.renderDropdown();
    },
    components: {
      PhilGovDetailCard,
      recipientCardComponent,
      // CheckoutPaymentComponent
    },
		computed: {
			...mapGetters('auth', [
				'authenticating',
				'authenticationError',
				'authenticationErrorCode',
				'authenticationSuccess'
			])
		},
    destroyed() {
      if (window.checkoutCompleted) window.checkoutCompleted = null;
    },
    methods: {
      ...mapActions('auth', ['login']),
      ...mapActions('customer', [ 'setLastFxCalcCurrencyId' ]),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async renderDropdown(){
        const self    = this;
        self.Dom7(".popover-commision-info-2.info").on('popover:open', function () {
          self.$$(".popover-commision-info-2.info").css({
            'visibility' : 'hidden',
          });
        });

        self.Dom7(".popover-commision-info-2.info").on('popover:opened', async function () {
          const parentPosTop = parseFloat(document.getElementById("infoCommisionIcon-2").getBoundingClientRect().top);
          const parentPosLeft = parseFloat(document.getElementById("infoCommisionIcon-2").getBoundingClientRect().left);

          var elHeight = parseFloat(self.$$(".popover-commision-info-2.info.modal-in").height());

          self.$$(".popover.info.modal-in .popover-angle").css({
            'margin-left' : (-9.00 / 2) + 'rem', // 8rem = popover width, 1rem = 16px = margin
            'top' : (elHeight/2) + 'px',
            'transform' : 'rotate(90deg)'
          });

          self.$$(".popover-commision-info-2.info.modal-in").css({
            'visibility' : 'visible',
            'left' : (parentPosLeft+40) + 'px',
            'top' : (parentPosTop-16) + 'px'
          });

          // CLOSE POP-UP AFTER 3 SECONDS
            setTimeout(function(){
              self.$f7.popover.close('.popover-commision-info-2.info.modal-in')
            }, 3000);

        });

      },

      createSettlement(){
        const self = this;
        var transactionData = self.$store.state.transaction;
        const createSettlementReq = this.$api.settlement.createSettlement(
          self.hostCountryId,
          self.totalAmountPayable,
          self.totalAmountPayable,
          transactionData.transactionIds);

        createSettlementReq.then(function(result){

          if(result.status == "2500"){
            transactionData.settlementId = result.result.id
            self.settlementId            = result.result.id
            self.updateSettlement()
          }else{
            self.showErrorCard( self.$t('sendmoney-error-general', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            self.hidePreloader()
          }
        });
      },

      createTransaction(){
        const self = this

        let createTrxReq = ""
        if(self.transactionTypeId == 1){// bill payment
          createTrxReq = this.$api.transaction.createBillPayment(
            self.beneficiaryId,
            self.homeObj.amountReal,
            self.hostObj.amountReal,
            self.commissionAmount,
            self.couponCode.trim(),
            self.totalAmountPayable,
            self.deliveryMethodId,
            self.bankExpressId,
            '');
        }else{ //remittance
          const paymentPurpose = ( self.paymentPurposeId < 0 ) ? self.paymentPurposeOther : self.paymentPurpose

          if(self.bankId == 4520 || self.bankId == 4521 || self.bankId == 4522){
            createTrxReq = this.$api.transaction.createPhilGovRemittance(
              self.homeObj.amountReal,
              self.hostObj.amountReal,
              self.commissionAmount,
              self.couponCode.trim(),
              self.totalAmountPayable,
              paymentPurpose);
          }else{
            createTrxReq = this.$api.transaction.createRemittance(
              self.beneficiaryId,
              self.homeObj.amountReal,
              self.hostObj.amountReal,
              self.commissionAmount,
              self.couponCode.trim(),
              self.totalAmountPayable,
              self.deliveryMethodId,
              self.bankExpressId,
              paymentPurpose);
          }

        }

        var transactionData = self.$store.state.transaction
        transactionData.transactionIds     = []
        transactionData.transactionTypeIds = []

        createTrxReq.then(function(reponse) {
          const statusCode = reponse.status
          if (statusCode == '0500') {
            self.transactionId            = reponse.result.id
            transactionData.transactionId = reponse.result.id

            transactionData.transactionIds.push(reponse.result.id)
            transactionData.transactionTypeIds.push(self.transactionTypeId)

             //CREATE SETTLEMENT
            self.createSettlement()

          } else if (statusCode == '0527' || statusCode == '0523') { // Max amount reached for routing
            self.showErrorCard(self.$t('sendmoney-error-'+statusCode, [reponse.message]))
            self.hidePreloader()
          } else { // Generic error
            self.showErrorCard( self.$t('sendmoney-error-general', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
            self.hidePreloader()
          }

        });

      },

      formatCurrency(num, dec) {
        let val = (Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100).toFixed(dec)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },

      handleConfirmContinue(){
        const self = this
        self.showPreloader()
        this.createTransaction()
        if(!window.Android && !window.webkit && self.paymentMethodId == 3) {
          self.checkWindow = window.open('/sendmoney-checkout?status=4', '_blank', "fullscreen=1");
          self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.checkoutCompleted(true);} }, 1000);
        }
      },

      showErrorCard(errorMessage) {
        this.alertCard.title      = errorMessage
        this.alertCard.alertClass = 'alert-danger'
        this.alertCard.show       = true
      },

      updateSettlement(){
        const self = this;
        var settlementDetails = {
					"langCode":"EN",
					"payments":{
						"paymentList":[
							{
								"paymentMethodId" : self.paymentMethodId,
								"payable"         : self.totalAmountPayable,
								"fee"             : self.convenienceFee,
								"feeByPercentage" : self.convenienceFeeByPercentage,
								"totalPayable"    : self.payable
							}
						]
					},
					"retailBranchId"        : self.$store.state.misc.appBranchId,
          "statusId"              : 0, // 1 for change payment method
				}

        const updateSettlement = this.$api.settlement.updateSettlement(self.settlementId, settlementDetails);
        updateSettlement.then(function() {
          self.updateLastFxCalcCurrencyId(self.homeCountryId); //  WA-396

          if(self.paymentMethodId == 3) {
            self.checkoutCreditPayment();
          }else if(self.paymentMethodId == 14 || self.paymentMethodId == 2){
            self.hidePreloader();
            self.$f7router.navigate("/sendmoney/payment-detail")
          }else{
            self.hidePreloader();
            self.$f7router.navigate("/sendmoney/payment-summary")
          }
        });
      },

      checkoutCreditPayment() {
        const self = this;
        this.$api.settlement.checkoutCreditPayment(self.settlementId).then(function(response) {
          if(response && response != undefined && response != '') {
            //self.checkoutPaymentURL = response;
            if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(response);
            } else {
              self.checkWindow = window.open(response, '_blank', "fullscreen=1");
            }
            // if(window.Android) {
            //   window.Android.getWandrCallback(JSON.stringify({ "type": 'open_url_in_popup', 'url': response }));
            // } else if(window.webkit) {
            //   window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'open_url_in_popup', 'url': response }));
            // } else if(self.checkWindow !== undefined) {
            //   self.checkWindow.document.write('<html><head><title>Sendmoney Checkout</title><style>iframe { border: none; width: 100%; height: 100%; position: absolute; }</style></head><body><iframe src="'+response+'" allow="payment"></iframe></body></html>');
            // }
          } else {
            self.hidePreloader();
          }
        });
      },

      checkoutCompleted(navigateToNextPage) {
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }
        if(navigateToNextPage) {
          this.$f7router.navigate("/sendmoney/payment-summary");
        }
      },

      /* WA-396 */
      updateLastFxCalcCurrencyId(currId){
        const self = this
        const updateLastFxCalcCurrencyIdPromise = this.$api.customer.updateLastFxCalcCurrencyId(currId)
        updateLastFxCalcCurrencyIdPromise.then((res)=>{
          if(res.status == "WN00435"){ // SUCCESS
            self.setLastFxCalcCurrencyId(currId)
          }else{ // WN00436, etc
            self.setLastFxCalcCurrencyId("0")
          }
        })
      },
      /* END OF WA-396 */

      handleBackButton(){
        this.$f7router.back({ transition: 'f7-push' })
      }

    }
  }
</script>